/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import {
  fragment,
  fragmentArray,
  array,
} from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import ProcessMonitorStatus from '@linc-technologies/linced-common/enums/process-monitor-status';
import type ProcessMonitorError from '@linc-technologies/linced-common/models/cron/process-monitor-error';
import type Progress from '@linc-technologies/linced-common/models/cron/progress';

// Proto: cron.ProcessMonitor.
export default class ProcessMonitor extends Model {
  declare [Type]: 'cron/process-monitor';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from
  // the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // name is the name of the process monitor
  @attr('string', { defaultValue: '' })
  declare name: string;

  // status is the status of the process monitor
  @attr('number', { defaultValue: 0 })
  declare status: EnumValue<typeof ProcessMonitorStatus>;

  @computed('status')
  get displayStatus() {
    return ProcessMonitorStatus.getLabel(this.status);
  }

  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  @fragment('cron/progress')
  declare progress: Progress | null;

  // processErrors is the process log. The API sends it in the `errors` key.
  // The serializer maps it, because Model.errors holds the validation errors
  // of a save.
  @fragmentArray('cron/process-monitor-error')
  declare processErrors: FragmentArray<ProcessMonitorError>;

  @array('string')
  declare resourceIds: StatefulArray<string>;
}
